module.exports = __webpack_public_path__ + "img/logo.f3dc79f2.svg";